export const ENV_DEV = 'dev';

export const ENV_PROD = 'prod';
